// Setting Vue Router

// Import
import store from "@/store";
import router from "@/routes/router";
import IVEConfig from "@/config/IVEConfig.js";

/**
 * - Description -
 * RouterService is a helper class that provides some facilities to navigate
 * the app. Its main aim is to contains in a single place all the routes methods,
 * in order to keep the maintainability of the entire routing system.
 *
 * - Usage -
 * Using RouterService
 *
 * import RouterService from '@/helpers/RouterService.js'
 * RouterService.goTo(path, params);
 */
export default {
    name: "RouterService",

    save(previousPath) {
        let navData = store.getters["AppState/getNavigationData"];
        navData.previousPath = previousPath;
        store.dispatch("AppState/setNavigationData", navData);
    },
    goTo(path) {
        console.debug("ROUTER.SERVICE - PATH is: ", path);
        let nextPath = "";
        if (path === "*goBack*") {
            this.goBack();
        } else {
            let pathStr = path;
            if (path.name !== undefined) {
                pathStr = path.name;
            }
            /*if(!(pathStr.includes("lab") && router.currentRoute.path.includes("lab"))) {
                this.save(router.currentRoute.path);

                console.debug("ROUTER.SERVICE - Navigation to Next path: ", nextPath);

            }*/

            this.save(router.currentRoute.path);
            nextPath = path;
            console.debug("ROUTER.SERVICE - Navigation to Next path: ", nextPath);
            router.push(nextPath);


        }
    },
    goToDefaultPath() {
        let userInfo = store.getters["UserState/getUserInfo"];
        if (IVEConfig.roles[userInfo.role].defaultPath !== undefined) {
            this.goTo(IVEConfig.roles[userInfo.role].defaultPath);
        } else {
            console.debug("ROUTER.SERVICE - No role for the user", userInfo.username, ". No navigation to defaultPath - go to login");
            this.goTo("/login");
        }
    },
    goBack() {
        let navData = store.getters["AppState/getNavigationData"];
        console.debug("ROUTER.SERVICE - go back", navData.previousPath);
        if (navData.previousPath === undefined || navData.previousPath === "" || navData.previousPath.includes("lab")) {
            this.goToDefaultPath();
        } else {
            router.back();
            //let nextPath = store.getters["AppState/getNavigationData"].previousPath;
            //router.push(nextPath);
        }
    },
};

